<template>
    <MyDocuments :isPublic="this._props.isPublic"></MyDocuments>
</template>

<script>
    import MyDocuments from "../components/MyDocuments";

    export default {
        name: "my-documents",
        props: {
            isPublic: {
                type: Boolean
            }
        },
        components: {
            MyDocuments,
        }
    };
</script>